import { TableBodyProps } from "../types";
import TableRow from "./TableRow";

const TableBody: React.FC<TableBodyProps> = (props) => {
  const {
    data,
    columns,
    selectableRows = true,
    selectedRows,
    onRowClick,
    onEventClick,
    onSelectCheckboxClick,
    disableSelection,
    columnsChild,
    CustomTableRowChild,
    childTableTitle,
    rowClassName,
  } = props;


  return (
    <>
      <tbody className="bg-white w-full ">
        {data.map((row: any, index: number) => {
          return (
            <TableRow
              key={index}
              row={row}
              columns={columns}
              selectedRows={selectedRows}
              selectableRows ={selectableRows}
              onRowClick={onRowClick}
              onEventClick={onEventClick}
              onSelectCheckboxClick={onSelectCheckboxClick}
              disableSelection={disableSelection}
              columnsChild={columnsChild}
              CustomTableRowChild={CustomTableRowChild}
              childTableTitle={childTableTitle}
              rowClassName={rowClassName}
            />
          );
        })}
      </tbody>
    </>
  );
};
export default TableBody;
